__turbopack_context__.v({
  "fill": "progress-bar-module-scss-module__7_q3ga__fill",
  "native": "progress-bar-module-scss-module__7_q3ga__native",
  "root": "progress-bar-module-scss-module__7_q3ga__root",
});
